module.exports = __webpack_public_path__ + "static/media/logo.ed4ae494.png";